// translations/common.ts
export const translations = {
    en: {
      'errors.insufficientCredits': 'Insufficient credits. Please purchase credits or subscribe.',
      'errors.xmlBlurredMessage': 'Download the complete XRechnung to see all data (uses 1 credit).',
      'errors.moneyBackGuarantee': '100% money back guarantee if XRechnung does not comply with requirements.',
      'errors.fetchUserStatusFailed': 'Failed to fetch user status',
      'errors.deductCreditFailed': 'Failed to deduct credit',
      'errors.downloadCheckFailed': 'Failed to check download',
      'errors.missingDownloadData': 'Missing download data',
      'errors.downloadCreationFailed': 'Failed to create download',
      'errors.signInRequired': 'Please sign in to continue',
      'errors.validationFailed': 'Validation failed. Please check your input.',
      'errors.missingRequiredFields': 'Please fill in all required fields',
      'errors.fileProcessingError': 'Error processing file: {message}',
      'errors.batchProcessingError': 'Some files failed to process',
      'errors.downloadPreparationFailed': 'Failed to prepare download',
  
      'seo.title': '{title} - Invoice-Converter.com',
      'seo.defaultDescription': 'Convert PDF invoices to XRechnung XML format easily with our AI-powered solution.',
      'seo.defaultTitle': 'PDF to XRechnung Converter',
  
      'common.welcome': 'Welcome, {{name}}!',
      'common.uploadInvoice': 'Upload Invoice',
      'common.to': 'to',
      'common.cancel': 'Cancel',
      'common.confirm': 'Confirm',
      'common.and': 'and',
      'common.comingSoon': '(coming soon)',
      'relatedTools.title': 'Related Invoice Conversion Tools',
  
      'seoContent.benefits': 'Benefits',
      'seoContent.features': 'Key Features',
      'seoContent.faq': 'Frequently Asked Questions',
      'seoContent.cta.title': 'Get Started',
      'seoContent.cta.description': 'Convert your PDF invoices to XRechnung-compliant XML files today. Simple, fast and GDPR-compliant.',
      'seoContent.cta.button': 'Try Free',
  
      'actions.retry': 'Retry',
  
      'feedback.button': 'Feedback?',
      'feedback.title': 'Help us improve!',
      'feedback.subtitle': 'We\'d love to hear from you!',
      'feedback.messageLabel': 'Your Message',
      'feedback.placeholder.message': 'What could be improved?',
      'feedback.placeholder.email': 'Your email (optional)',
      'feedback.submit': 'Send Feedback',
      'feedback.sending': 'Sending...',
      'feedback.success': 'Thank you for your feedback! 🎉',
  
      'footer.quickLinks': 'Quick Links',
      'footer.services': 'Features', // Grouped here as a general site link/element
      'footer.services.title': 'Our Services',
      'footer.services.pdfToXrechnung': 'PDF to XRechnung',
      'footer.services.xrechnungToPdf': 'XRechnung to PDF',
      'footer.services.xrechnungViewer': 'XRechnung Viewer',
      'footer.resources.title': 'Resources',
      'footer.resources.blog': 'XRechnung Guide & Blog',
      'footer.resources.pricing': 'Simple Pricing',
      'footer.resources.climate': 'Climate Contribution',
      'footer.company.title': 'Company',
      'footer.company.imprint': 'Imprint',
      'footer.company.privacy': 'Privacy Policy',
      'footer.company.dpa': 'Data Processing Agreement',
      'footer.company.terms': 'Terms & Conditions',
      'footer.cta.title': 'Ready to get started?',
      
      'convert.title': 'Convert Your Invoices',
      'convert.description': 'Choose a conversion tool to get started with your invoice processing',
      
      'notFound.title': 'Page Not Found',
      'notFound.message': 'The page you are looking for does not exist.',
      
      'footer.missionStatement': 'Empowering businesses across Europe to effortlessly comply with XRechnung regulations. Join hundreds who\'ve automated their invoice conversion process.',
      'footer.stat1': '20,000+ invoices processed',
      'footer.stat2': 'Fast & Secure',
      'footer.stat3': 'Trusted by hundreds',
      'footer.resources.changelog': 'Product Updates',
      'footer.contact.title': 'Get in Touch',
      'footer.cta.button': 'Start Converting',
      'footer.madeWith': 'Made with',
      'footer.madeLocation': 'in Europe',
      'footer.gdprCompliant': 'GDPR Compliant',
      'footer.uptime': '>99% Uptime',
      
      'changelog.title': 'Product Updates',
      'changelog.subtitle': 'Latest features and improvements to Invoice Converter',
      'changelog.items.ai.title': 'Enhanced AI Processing',
      'changelog.items.ai.desc': 'Improved invoice data extraction with better accuracy and reliability.',
      'changelog.items.zugferd.title': 'ZUGFeRD Support',
      'changelog.items.zugferd.desc': 'Added full support for ZUGFeRD PDF generation with embedded XML data.',
      'changelog.items.cii.title': 'CII Format Support',
      'changelog.items.cii.desc': 'Support for Cross Industry Invoice (CII) format for XRechnung compliance.',
      'changelog.items.multiUpload.title': 'Multi-File Upload',
      'changelog.items.multiUpload.desc': 'Process multiple invoices simultaneously for increased efficiency.',
      'changelog.items.credits.title': 'Credit System',
      'changelog.items.credits.desc': 'Flexible pay-per-use credit system with subscription options.',
      'changelog.items.ui.title': 'Improved UI/UX',
      'changelog.items.ui.desc': 'Enhanced user interface with better navigation and visual feedback.',
      'changelog.items.seo.title': 'Better SEO',
      'changelog.items.seo.desc': 'Improved search engine optimization and page performance.',
      'changelog.items.security.title': 'Enhanced Security',
      'changelog.items.security.desc': 'Strengthened security measures and data protection.',
      'changelog.items.validation.title': 'Validation Improvements',
      'changelog.items.validation.desc': 'Better validation and error handling for invoice processing.',
    },
    de: {
      'errors.insufficientCredits': 'Nicht genügend Credits. Bitte Credits kaufen oder abonnieren.',
      'errors.xmlBlurredMessage': 'Laden Sie die vollständige XRechnung herunter, um alle Daten zu sehen (verwendet 1 Credit).',
      'errors.moneyBackGuarantee': '100% Geld-zurück-Garantie, falls die XRechnung nicht den Anforderungen entspricht.',
      'errors.fetchUserStatusFailed': 'Fehler beim Abrufen des Benutzerstatus',
      'errors.deductCreditFailed': 'Fehler beim Abziehen des Credits',
      'errors.downloadCheckFailed': 'Fehler beim Überprüfen des Downloads',
      'errors.missingDownloadData': 'Fehlende Download-Daten',
      'errors.downloadCreationFailed': 'Fehler beim Erstellen des Downloads',
      'errors.signInRequired': 'Bitte melden Sie sich an, um fortzufahren',
      'errors.validationFailed': 'Validierung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingabe.',
      'errors.missingRequiredFields': 'Bitte füllen Sie alle erforderlichen Felder aus',
      'errors.fileProcessingError': 'Fehler beim Verarbeiten der Datei: {message}',
      'errors.batchProcessingError': 'Einige Dateien konnten nicht verarbeitet werden',
      'errors.downloadPreparationFailed': 'Fehler beim Vorbereiten des Downloads',
  
      // This nested errors object was only present in the original DE section
      'errors': {
        'pdfOnly': 'Es sind nur PDF-Dateien erlaubt',
        'fileTooLarge': 'Datei zu groß. Maximale Größe ist 10MB',
        'noTextExtracted': 'Text konnte nicht aus PDF extrahiert werden. Bitte stellen Sie sicher, dass die PDF Text enthält und nicht passwortgeschützt ist.',
        'processingFailed': 'Rechnungsdaten konnten nicht aus der PDF verarbeitet werden',
        'invalidResponse': 'Ungültige Antwort vom Server. Bitte versuchen Sie es erneut.',
        'authenticationRequired': 'Authentifizierung erforderlich. Bitte melden Sie sich an.',
        'upload': {
          'noFileSelected': 'Bitte wählen Sie eine Datei aus.',
        }
      },
  
      'seo.title': '{title} - Invoice-Converter.com',
      'seo.defaultDescription': 'Konvertieren Sie PDF-Rechnungen einfach in das XRechnung XML-Format mit unserer KI-gestützten Lösung.',
      'seo.defaultTitle': 'PDF zu XRechnung Konverter',
  
      'common.welcome': 'Willkommen, {{name}}!',
      'common.uploadInvoice': 'Rechnung hochladen',
      'common.and': 'und',
      'common.to': 'zu',
      'common.cancel': 'Abbrechen',
      'common.confirm': 'Bestätigen',
      'common.comingSoon': '(kommt bald)',
      'relatedTools.title': 'Verwandte Konvertierungstools',
  
      'seoContent.benefits': 'Vorteile',
      'seoContent.features': 'Hauptfunktionen',
      'seoContent.faq': 'Häufig gestellte Fragen',
      'seoContent.cta.title': 'Jetzt loslegen',
      'seoContent.cta.description': 'Konvertieren Sie Ihre PDF-Rechnungen noch heute in XRechnung-konforme XML-Dateien. Einfach, schnell und DSGVO-konform.',
      'seoContent.cta.button': 'Kostenlos testen',
  
      'actions.retry': 'Wiederholen',
  
      'feedback.button': 'Feedback?',
      'feedback.title': 'Helfen Sie uns besser zu werden!',
      'feedback.subtitle': 'Wir würden gerne von Ihnen hören!',
      'feedback.messageLabel': 'Ihre Nachricht',
      'feedback.placeholder.message': 'Was können wir verbessern?',
      'feedback.placeholder.email': 'Ihre E-Mail (optional)',
      'feedback.submit': 'Feedback senden',
      'feedback.sending': 'Wird gesendet...',
      'feedback.success': 'Vielen Dank für Ihr Feedback! 🎉',
  
      'footer.quickLinks': 'Schnellzugriff',
      'footer.services': 'Features', // Grouped here as a general site link/element
      'footer.services.title': 'Unsere Services',
      'footer.services.pdfToXrechnung': 'PDF zu XRechnung',
      'footer.services.xrechnungToPdf': 'XRechnung zu PDF',
      'footer.services.xrechnungViewer': 'XRechnung Viewer',
      'footer.resources.title': 'Ressourcen',
      'footer.resources.blog': 'XRechnung Guide & Blog',
      'footer.resources.pricing': 'Einfache Preise',
      'footer.resources.climate': 'Klimabeitrag',
      'footer.company.title': 'Unternehmen',
      'footer.company.imprint': 'Impressum',
      'footer.company.privacy': 'Datenschutzerklärung',
      'footer.company.dpa': 'Auftragsverarbeitungsvertrag',
      'footer.company.terms': 'AGB',
      'footer.cta.title': 'Bereit loszulegen?',
      
      'convert.title': 'Rechnungen konvertieren',
      'convert.description': 'Wählen Sie ein Konvertierungstool, um mit der Rechnungsverarbeitung zu beginnen',
      
      'notFound.title': 'Seite nicht gefunden',
      'notFound.message': 'Die gesuchte Seite existiert nicht.',
      
      'footer.missionStatement': 'Wir unterstützen Unternehmen in ganz Europa bei der mühelosen Einhaltung der XRechnung-Vorschriften. Schließen Sie sich hunderten Firmen an, die ihre Rechnungskonvertierung automatisiert haben.',
      'footer.stat1': '20.000+ Rechnungen verarbeitet',
      'footer.stat2': 'Schnell & Sicher',
      'footer.stat3': 'Hunderte zufriedene Kunden',
      'footer.resources.changelog': 'Produkt-Updates',
      'footer.contact.title': 'Kontakt aufnehmen',
      'footer.cta.button': 'Jetzt konvertieren',
      'footer.madeWith': 'Gemacht mit',
      'footer.madeLocation': 'in Europa',
      'footer.gdprCompliant': 'DSGVO-konform',
      'footer.uptime': '>99% Verfügbarkeit',
      
      'changelog.title': 'Produkt-Updates',
      'changelog.subtitle': 'Neueste Features und Verbesserungen des Invoice Converters',
      'changelog.items.ai.title': 'Verbesserte KI-Verarbeitung',
      'changelog.items.ai.desc': 'Verbesserte Extraktion von Rechnungsdaten mit höherer Genauigkeit und Zuverlässigkeit.',
      'changelog.items.zugferd.title': 'ZUGFeRD-Unterstützung',
      'changelog.items.zugferd.desc': 'Vollständige Unterstützung für ZUGFeRD-PDF-Generierung mit eingebetteten XML-Daten.',
      'changelog.items.cii.title': 'CII-Format-Unterstützung',
      'changelog.items.cii.desc': 'Unterstützung für Cross Industry Invoice (CII) Format für XRechnung-Compliance.',
      'changelog.items.multiUpload.title': 'Multi-Datei-Upload',
      'changelog.items.multiUpload.desc': 'Gleichzeitige Verarbeitung mehrerer Rechnungen für erhöhte Effizienz.',
      'changelog.items.credits.title': 'Credit-System',
      'changelog.items.credits.desc': 'Flexibles Pay-per-Use Credit-System mit Abonnement-Optionen.',
      'changelog.items.ui.title': 'Verbesserte UI/UX',
      'changelog.items.ui.desc': 'Verbesserte Benutzeroberfläche mit besserer Navigation und visuellem Feedback.',
      'changelog.items.seo.title': 'Bessere SEO',
      'changelog.items.seo.desc': 'Verbesserte Suchmaschinenoptimierung und Seitenleistung.',
      'changelog.items.security.title': 'Erweiterte Sicherheit',
      'changelog.items.security.desc': 'Verstärkte Sicherheitsmaßnahmen und Datenschutz.',
      'changelog.items.validation.title': 'Validierungs-Verbesserungen',
      'changelog.items.validation.desc': 'Bessere Validierung und Fehlerbehandlung bei der Rechnungsverarbeitung.',
    }
  };